module.exports = __webpack_public_path__ + "media/images/project/down-arrow-94f6a0894c725816d6eac3758d411ad5.svg";